import React, { useState , useEffect , useRef } from "react";
// import AliceCarousel from "react-alice-carousel";
import { motion } from "framer-motion";
// import {
//   FcAcceptDatabase,
//   FcBullish,
//   FcTemplate,
//   FcPositiveDynamic,
//   FcCommandLine,
//   FcMindMap,
// } from "react-icons/fc";
import { Swiper, SwiperSlide } from "swiper/react";
import {  Autoplay, EffectCoverflow, Pagination } from "swiper";
import { Link } from "react-router-dom";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "./style.css";

// const responsive = {
//   0: { items: 1 },
//   568: { items: 2 },
//   1024: { items: 3 },
// };
const itemlist = [
  
  {
    img: "./5.png",
    link: "/ADPDatabase",
    // courseName: "Associate Degree Program",
    // courseLength: "Database Management",
    // icon: <FcAcceptDatabase className="w-10 h-10" />,
  },

  {
    img: "./3.png",
    link: "/ADPWDD&D",
    // courseName: "Associate Degree Program",
    // courseLength: "Computer Networking",
    // icon: <FcMindMap className="w-10 h-10" />,
  },
  
 
  {
    img: "./7.png",
    link: "/ADPCommerce",
    
    // courseName: "Associate Degree Program",
    // courseLength: "Web Design and Development",
    // icon: <FcTemplate className="w-10 h-10" />,
  },
  
  {
    img: "./1.png",
    link: "/Mba2years",
    // courseName: "Associate Degree Program",
    // courseLength: "Bachleors of Business Administration",
    // icon: <FcBullish className="w-10 h-10" />,
  },
  {
    img: "./4.png",
    link: "/BBA4YEARS",
    // courseName: "Associate Degree Program",
    // courseLength: "Bachleors of Business Administration",
    // icon: <FcBullish className="w-10 h-10" />,
  },
  {
    img: "./2.png",
    link: "/BSCS4Years",
    // courseName: "Associate Degree Program",
    // courseLength: "Business and Commerce",
    // icon: <FcPositiveDynamic className="w-10 h-10" />,
  },
  {
    img: "./6.png",
    link: "/ADPNetworking",
    // courseName: "Bachleors of Science in Computer Science",
    // courseLength: "4 years degree program",
    // icon: <FcCommandLine className="w-10 h-10" />,
  },
];

const Programs = () => {

  const [appeared, setAppeared] = useState(false);

  const handleLinkClick = (e, link) => {
    e.preventDefault();
    setAppeared(true);

    setTimeout(() => {
      window.location.href = link;
    }, 300); // Delay before navigating to the link (adjust as needed) 
  };


  const swiperRef = useRef(null);

  useEffect(() => {
    // const swiper = swiperRef.current.swiper;
    const autoplayDelay = 2000; // Adjust the delay as needed (in milliseconds)

    const autoplay = () => {
      // const currentSlideIndex = swiper.activeIndex;

      // if (currentSlideIndex === itemlist.length - 1) {
      //   swiper.slideTo(0); // Go to the first slide if it's the last slide
      // } else {
      //   swiper.slideNext();
      // }
    };

    const intervalId = setInterval(autoplay, autoplayDelay);
    // swiper.on("slideChangeTransitionEnd", () => {
    //   clearInterval(intervalId);
    //   intervalId = setInterval(autoplay, autoplayDelay);
    // });

    return () => {
      clearInterval(intervalId);
    };
  }, []);
  return (
    <div className="h-[600px] mb-[120px]  flex flex-col items-center w-[70%] m-auto my-28 ">
      <div className="mb-12">
        <motion.div
          initial={{ opacity: 0, x: -80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ type: "spring", duration: 1.5 }}
          className="font-bold text-4xl mb-1 my-24 "
        >
          ACADEMIC PROGRAMS
        </motion.div>
        <div className="bg-maroon w-48 md:w-96 h-1 ml-4"></div>
      </div>
      <Swiper
          ref={swiperRef}
          effect={"coverflow"}
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={"auto"}
          loop={true}
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }}
          pagination={true}
          modules={[EffectCoverflow, Pagination, Autoplay]}
          className="swiper"
          autoplay={{ delay: 2000 }} // Add autoplay prop with delay value (in milliseconds)
          // initialSlide={Math.floor(itemlist.length / 2)}
      >
        {itemlist?.map((item) => (
          <SwiperSlide>
            <div
              className="swiper-slide w-[400px] h-[400px]  drop-shadow-xl bg-white flex flex-col justify-start items-center
           hover:scale-105 transition-all duration-200 overflow-hidden hover:shadow-lg"
            >
             
             <Link to={item.link} 
             className={`link-appear ${appeared ? 'appeared' : ''}`}
             onClick={(e) => handleLinkClick(e, item.link)}>
               <img
                src={item.img}
                alt="Programs"
                data-value="1"
                className="w-full h-full  hover:scale-110 transition-all duration-300 cover"
              />
              </Link>
              <div className="flex justify-center items-start space-x-4 pt-8 md:p-6 w-full h-12 ">
                {item.icon}
                {/* <div className="flex flex-col w-full justify-center font-medium text-sm tracking-wide">
                  <h1 className="text-sm">{item.courseName}</h1>
                  <h1 className="text-maroon">{item.courseLength}</h1>
        </div>*/}
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      {/* <Swiper
         ref={swiperRef}
         effect={"coverflow"}
        slidesPerView={"auto"}
        spaceBetween={30}
        centeredSlides={true}
        loop={true}
        // coverflowEffect={{
        //   rotate: 50,
        //   stretch: 0,
        //   depth: 100,
        //   modifier: 1,
        //   slideShadows: true,
        // }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Pagination, Autoplay]}
        autoplay={{ delay: 2000 }} 

        className="mySwiper"
      >
         {itemlist?.map((item) => (
        <SwiperSlide>
          <div
              className="swiper-slide w-[400px] h-[400px]  drop-shadow-xl bg-white flex flex-col justify-start items-center
           hover:scale-105 transition-all duration-200 overflow-hidden hover:shadow-lg"
            >
              <Link to={item.link} 
             className={`link-appear ${appeared ? 'appeared' : ''}`}
             onClick={(e) => handleLinkClick(e, item.link)}>
               <img
                src={item.img}
                alt="Programs"
                data-value="1"
                className="w-full h-full  hover:scale-110 transition-all duration-300 cover"
              />
              </Link>
            </div>
            </SwiperSlide>
            ))}
      </Swiper> */}
    </div>
  );
};

export default Programs;
